module.exports = __webpack_public_path__ + "static/media/uy.2ac18c6e.svg";